import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { catalogCreateOtherCostTemplate } from '../catalogUerOtherCostTemplatesQueries';

interface IUseCreateOtherCostTemplate {
    onSuccessHandler: () => void;
}

export const useCreateOtherCostTemplate = ({ onSuccessHandler }: IUseCreateOtherCostTemplate) => {
    const [
        createOtherCostTemplateData,
        createOtherCostTemplateStatus,
        createOtherCostTemplateError,
        createOtherCostTemplateRequest,
    ] = useRequest({
        requestId: 'createOtherCostTemplate',
        query: catalogCreateOtherCostTemplate,
        withEffect: false,
        dependenciesUpdater: onSuccessHandler,
    });
    const [resetCreatingData] = useResetStoreData({ requestId: 'createOtherCostTemplate' });

    const isCreatingInProgress = createOtherCostTemplateStatus === RequestStatus.FETCHING;

    return {
        createOtherCostTemplateData: createOtherCostTemplateData?.createCatalogUEROtherCostTemplate,
        createOtherCostTemplateStatus,
        createOtherCostTemplateError,
        createOtherCostTemplateRequest,
        resetCreatingData,
        isCreatingInProgress,
    };
};
